import { getUsuariosCache, carregarUsuarios } from "./dataCache";

let _loadPromise = null;

function notificar() {
  window.dispatchEvent(new Event("usuarios:changed"));
}

export async function recarregarUsuarios(instituicaoId) {
  const lista = await carregarUsuarios(instituicaoId);
  notificar();
  return lista;
}

export async function recarregarSeNecessario(instituicaoId) {
  const cache = getUsuariosCache();
  if (cache.length > 0) return cache;
  if (!_loadPromise) {
    _loadPromise = recarregarUsuarios(instituicaoId).finally(() => {
      _loadPromise = null;
    });
  }
  return _loadPromise;
}

export function getUsuarios(instituicaoId) {
  const cache = getUsuariosCache();
  if (cache.length === 0 && !_loadPromise) {
    recarregarSeNecessario(instituicaoId).catch(() => {});
  }
  return cache;
}

export function getNomeUsuario(id, fallback = "Não identificado") {
  if (!id) return fallback;
  const cache = getUsuariosCache();
  const u = cache.find((u) => String(u.id) === String(id));
  return u?.nome || fallback;
}
